var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar3Icon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_41703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0078 4.54585H23.7578V2.10156H21.2578V4.54585H8.75781V2.10156H6.25781V4.54585H5.00781C3.63281 4.54585 2.50781 5.64578 2.50781 6.99013V26.5444C2.50781 27.8888 3.63281 28.9887 5.00781 28.9887H25.0078C26.3828 28.9887 27.5078 27.8888 27.5078 26.5444V6.99013C27.5078 5.64578 26.3828 4.54585 25.0078 4.54585ZM25.0078 26.5444H5.00781V10.6566H25.0078V26.5444Z",
    fill: "#1F3864"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar3Icon);
export default __webpack_public_path__ + "static/media/calendar3-icon.4ab9cb0b6b4e745f4655dfc2864ae30b.svg";
export { ForwardRef as ReactComponent };